module.exports = __webpack_public_path__ + "static/media/vector_background.f9801ffc.svg";